export default __webpack_public_path__ + "static/media/2star.4a823756.png";